import UserClassroomDirectoryTable from "@/users/UserClassroomDirectoryTable";
import useUser from "@/users/useUser";
import useUserClassroomGet from "@/users/useUserClassroomGet";

const PAGE_SIZE = 10;

const PAYLOAD = { hide_archived: true };

const ClassesTable = () => {
  const { data: user } = useUser();
  const {
    data: { results: classrooms = [], count = 0 } = {},
    loading: loadingClasses,
    controls,
    fetchClassrooms,
  } = useUserClassroomGet(user.id, PAYLOAD, PAGE_SIZE);

  return (
    <UserClassroomDirectoryTable
      classrooms={classrooms}
      count={count}
      isLoading={loadingClasses}
      controls={controls}
      fetchClassrooms={fetchClassrooms}
      pageSize={PAGE_SIZE}
    />
  );
};

export default ClassesTable;
